module.exports = __webpack_public_path__ + "static/media/20_Natascha_L_webfinal.70543cc6.jpg";